$(document).ready(function () {
    CouponEvents();
    externalEvents();

    $(document).on("click", ".js-checkout-progress-button", function () {
        var step = $(this).attr("data-next");
        SetStep(step, SetStepHandler);
    });
});

function CouponEvents() {
    $(document).on("click", ".js-coupon-collapse-button", function () {
        $(".js-coupon-colapse").slideToggle()
    });

    $(document).on("keyup", ".js-input-coupon-code", function () {
        if ($(this).val().length > 0) {
            $(".js-btn-use-coupon").prop("disabled", false);
        }
        else {
            $(".js-btn-use-coupon").prop("disabled", "disabled");
        }
    });

    GenerateEvent("paste", ".js-input-coupon-code", function () {
        $(".js-input-coupon-code").trigger("keyup");
    });

    GenerateEvent("cut", ".js-input-coupon-code", function () {
        $(".js-input-coupon-code").trigger("keyup");
    });

    $(document).on("submit", ".js-coupon-form", function () {
        var CouponCode = $(".js-input-coupon-code").val();

        if (typeof CouponCode == "string" && CouponCode != "") {
            UseCoupon(CouponCode, function (status, dt) {
                if (status) {
                    $(".js-input-coupon-code").val("");
                    RefreshOrderSummary();
                }
                else {
                    SwalGenerate("error", dt, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }
            });
        }

        return false;
    });

    $(document).on("click", ".js-btn-use-coupon-item", function () {
        var couponCode = $(this).attr("data-code");

        if (!couponCode)
            return;

        $(".js-input-coupon-code").val(couponCode);
        $(".js-coupon-form").trigger("submit");
    });

    $(document).on("click", ".js-remove-coupon", function () {
        DeleteUserCoupon();
    });
}

function externalEvents() {
    $(document).on("click", ".tabby-logo", function () {
        var tabbyElement = document.querySelector(".styles__containerPortal--c9f84").shadowRoot.querySelector(".styles__tabbyPromoSnippet--ed9ac");
        $(tabbyElement).trigger("click");
    });

    $(document).on("click", ".tamara-logo", function () {
        var tamaraElement = document.querySelector(".js-cart-tamarawidget").shadowRoot.querySelector(".tamara-summary-widget__container");
        $(tamaraElement).trigger("click");
    });
}